import { SubscriptionGetSummaryForUrlArgs } from '@/generated/graphql.mia'
import { GET_SUMMARY_FOR_URL } from '@/graphql/mia/subscriptions/summary'
import { useSubscription } from '@vue/apollo-composable'
import { useCustomParams } from '@/composables/useCustomParams'
import { reactive, watch } from 'vue'
import { BaseApiMessage } from '@/types/api'

export const useSummary = () => {
  const { url } = useCustomParams()

  const { loading: getSummaryForUrlLoading, onResult: getSummaryForUrlOnResult } = useSubscription<
    { getSummaryForUrl: string },
    SubscriptionGetSummaryForUrlArgs
  >(
    GET_SUMMARY_FOR_URL,
    {
      url: url!
    },
    {
      clientId: 'mia',
      enabled: typeof url !== 'undefined'
    }
  )

  const summaryMessage = reactive({
    content: '',
    role: 'assistant'
  } as BaseApiMessage)

  getSummaryForUrlOnResult(res => {
    const summaryChunk = res.data?.getSummaryForUrl

    if (typeof summaryChunk !== 'undefined') summaryMessage.content += summaryChunk
  })

  return { summaryMessage, loading: getSummaryForUrlLoading }
}
